import fetchWrapper from '@repo/fetcher';

function getCoursePrice(courseId, promoCode) {
    if (courseId) {
        const query = promoCode ? `?promoCode=${promoCode}` : '';

        return fetchWrapper.get(`/courses/${courseId}/price${query}`);
    }
}

function getPaymentClientToken(userId) {
    return fetchWrapper.get(`/users/${userId}/payments/token`);
}

function createOrder(userId, data) {
    return fetchWrapper.post(`/users/${userId}/payments/orders`, data);
}

function webhookPayment(userId, data) {
    return fetchWrapper.post(`/users/${userId}/payments/webhook`, data);
}

function getPromoCode(promoCode) {
    return fetchWrapper.get(`/promocodes/${promoCode}`);
}

function getPaymentPlan(promoCode) {
    const query = promoCode ? `?promoCode=${promoCode}` : '';

    return fetchWrapper.get(`/plans${query}`);
}

const buyPlan = (userId, planId, promoCode, orderId, affiliate) => {
    return fetchWrapper.post(`/users/${userId}/plans/${planId}/buy`, {
        orderId,
        promoCode,
        affiliate,
    });
};

const paymentService = {
    getCoursePrice,
    getPaymentClientToken,
    createOrder,
    webhookPayment,
    getPromoCode,
    getPaymentPlan,
    buyPlan,
};

export default paymentService;
